import { render, staticRenderFns } from "./BuyOrSellLands.vue?vue&type=template&id=0817a976&scoped=true&"
import script from "./BuyOrSellLands.vue?vue&type=script&lang=js&"
export * from "./BuyOrSellLands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0817a976",
  null
  
)

export default component.exports